import mobile_util from "../mobile/mobile_util"
import jSecure from "@linkedin/jsecure"
import scribdAuthorize from "../scribd/scribd_oauth.js"
;(function ($$, $) {
  // Extend Slideshare object

  $$.extend = function (destination, source, callback) {
    for (let property in source) {
      destination[property] = source[property]
    }
    if ($$.dev) {
      destination.__noSuchMethod__ = function (prop, args) {
        error(prop, " : no such method exists", args)
      }
    }
    if ($.isFunction(callback)) {
      callback()
    }
    return destination
  }

  // Update the main_navbar padding bottom based on the height of the entire nav_bar, including the TOS banner
  const updateMainNavPaddingBottom = function () {
    // Note that this should be deleted when we move to foundation_layout
    let $mainNavbar = $("#main_navbar")
    let $navBarInner = $(".navbar-inner")
    let $tosBanner = $(".j-tos-update-banner")
    // TODO: incluse subNav into mainNavbar so we don't have to count them separately.
    let $subNav = $mainNavbar.find(".sub-navbar")

    let addedHeight = $navBarInner.height() + $subNav.height()

    if ($tosBanner.is(":visible")) {
      addedHeight += $tosBanner.height()
    }

    $mainNavbar.css("padding-bottom", addedHeight)
  }

  const isEuLocale = function (locales) {
    // top tier EU locales. If we see any of these, we must show the banner
    locales = locales.map(function (locale) {
      return locale.toLowerCase()
    })
    let euTier1 = ["en-gb", "pt-pt", "de", "de-de", "fr", "fr-fr", "it", "it-it", "nl", "nl-nl", "es", "es-es"]
    for (let i = 0; i < locales.length; i++) {
      let locale = locales[i]
      if (euTier1.indexOf(locale) != -1) {
        return true
      }
    }
    if (locales.indexOf("pt") != -1 && locales.indexOf("pt-br") == -1) {
      return true
    } else if (locales.indexOf("en") != -1 && locales.indexOf("en-us") == -1) {
      return true
    } else {
      return false
    }
  }

  $$.extend(window, {
    log:
      $$.dev && window.console
        ? function () {
            try {
              console.log.apply(console, arguments)
            } catch (e) {}
          }
        : function () {},

    error:
      $$.dev && window.console
        ? function () {
            try {
              console.error.apply(console, arguments)
            } catch (e) {}
          }
        : function () {},

    dir:
      $$.dev && window.console
        ? function (a) {
            try {
              console.dir(a)
            } catch (e) {}
          }
        : function () {},

    info:
      $$.dev && window.console
        ? function (a) {
            try {
              console.info(a)
            } catch (e) {}
          }
        : function () {},

    getUrlVars: function (url) {
      url = url ? url : window.location.href
      let vars = [],
        hash
      let hashes = url.slice(url.indexOf("?") + 1).split("&")
      for (let i = 0; i < hashes.length; i++) {
        hash = hashes[i].split("=")
        vars.push(hash[0])
        vars[hash[0]] = hash[1]
      }
      return vars
    },

    getUrlVarsAsObject: function (url) {
      url = url ? url : window.location.href
      let vars = {}
      let hash
      let hashes = url.slice(url.indexOf("?") + 1).split("&")
      for (let i = 0; i < hashes.length; i++) {
        hash = hashes[i].split("=")
        vars[hash[0]] = decodeURIComponent(hash[1])
      }
      return vars
    },

    getUrlVar: function (name, url) {
      return window.getUrlVars(url)[name]
    },

    addUrlVar: function (url, name, value) {
      let urlWithoutParams = url
      let urlWithoutParamsLength = url.indexOf("?")
      let params = getUrlVarsAsObject(url)
      params[name] = value
      if (urlWithoutParamsLength > 0) {
        urlWithoutParams = url.slice(0, urlWithoutParamsLength)
      }
      return urlWithoutParams + "?" + $.param(params)
    },

    location_without_params: function () {
      return document.location.protocol + "//" + document.location.host + document.location.pathname
    },

    isInternalRedirect: function (url) {
      url = decodeURIComponent(url)
      let dummy_anchor = document.createElement("a")
      dummy_anchor.href = jSecure.sanitizeUrl(url)
      let is_valid_protocol = /^https?:$/.test(dummy_anchor.protocol)
      let is_valid_hostname = new RegExp("^" + pregQuote(location.hostname) + "$").test(dummy_anchor.hostname)
      return is_valid_protocol && is_valid_hostname
    },

    cookie: function (name, value, options) {
      /* view http://plugins.jquery.com/files/jquery.cookie.js.txt
        here we directly append this to window object instead of jQuery */
      if (typeof value != "undefined") {
        options = options || {}
        if (value === null) {
          value = ""
          options.expires = -1
        }
        let expires = ""
        if (options.expires && (typeof options.expires == "number" || options.expires.toUTCString)) {
          let date
          if (typeof options.expires == "number") {
            date = new Date()
            date.setTime(date.getTime() + options.expires * 24 * 60 * 60 * 1000)
          } else {
            date = options.expires
          }
          expires = "; expires=" + date.toUTCString()
        }
        let path = options.path ? "; path=" + options.path : ""
        let domain = options.domain ? "; domain=" + options.domain : ""
        let secure = options.secure ? "; secure" : ""
        document.cookie = [name, "=", encodeURIComponent(value), expires, path, domain, secure].join("")
      } else {
        let cookieValue = null
        if (document.cookie && document.cookie !== "") {
          let cookies = document.cookie.split(";")
          for (let i = 0; i < cookies.length; i++) {
            let cookie = jQuery.trim(cookies[i])
            if (cookie.substring(0, name.length + 1) == name + "=") {
              cookieValue = decodeURIComponent(cookie.substring(name.length + 1))
              break
            }
          }
        }
        return cookieValue
      }
    },

    // Check if browser is MSIE ($.browser.msie is obsolete from jQuery 1.9)
    // From http://msdn.microsoft.com/en-us/library/ms537509%28v=vs.85%29.aspx
    isBrowserMSIE: function () {
      if (navigator.appName == "Microsoft Internet Explorer") {
        let ua = navigator.userAgent
        let re = new RegExp("MSIE ([0-9]{1,}[.0-9]{0,})")
        if (re.exec(ua) != null) {
          return true
        }
      }
      return false
    },

    location_without_params: function () {
      return document.location.protocol + "//" + document.location.host + document.location.pathname
    },
  })

  // TOS Update Banner
  $(document).ready(function () {
    let langs
    if (navigator.languages) {
      langs = navigator.languages
    } else {
      if (navigator.language) {
        langs = [navigator.language]
      } else {
        langs = []
      }
    }
  })

  $$.extend(String.prototype, {
    s: function (s) {
      if (s === "" || s) {
        return s
      }
      if (this.str === "" || this.str) {
        return this.str
      }
      return this
    },
    startsWith: function (pattern, s) {
      return this.s(s).indexOf(pattern) === 0
    },
  })

  $$.extend($$, {
    action_from_email_check: function () {
      // instead of auto_login auth_code this auth_code is used in like email to verify the user
      //
      // TODO (June 15, 2021): I removed handling of auth_code from the backend. This left behind
      // because it does not pass auth_code to the backend, instead just triggers login
      // model. This probably a good candidate for JS cleanup
      let auth_code = getUrlVar("auth_code")
      if (auth_code && !slideshare_object.user.loggedin) {
        let login_source = getUrlVar("login_source"),
          from = getUrlVar("from"),
          login_url = "/signup?"
        login_url += from ? "from=" + from + "&" : ""
        login_url += login_source ? "login_source=" + login_source : ""
        window.initiate_login_modal(login_url, "#login_modal")
      }
    },

    ga: function (category, action, opt_label, opt_value, opt_noninteraction) {
      opt_noninteraction = !!opt_noninteraction
      window._gaq && window._gaq.push(["_trackEvent", category, action, opt_label, opt_value, opt_noninteraction])
    },

    isHomePage: function () {
      return window.location.pathname == "/"
    },

    setLanguageSelector: function () {
      // Set current Language in selector
      try {
        let cur_subdomain = window.location.href.match(/:\/\/([^.]*)/)[1]
        $(".j-languages-selector .j-" + cur_subdomain).addClass("active")
      } catch (e) {
        $(".j-languages-selector .j-www").addClass("active")
      }
    },

    loadGAandComscore: function () {
      let s = document.getElementsByTagName("script")[0]
      let isSSL = document.location.protocol === "https:"

      this.loadGA()
    },

    loadGA: function () {
      let s = document.getElementsByTagName("script")[0]
      let isSSL = document.location.protocol === "https:"

      let ga = document.createElement("script")
      ga.async = true
      ga.src = (isSSL ? "//ssl" : "//www") + ".google-analytics.com/ga.js"
      s.parentNode.insertBefore(ga, s)
    },

    localizeForOtherLanguages: function () {
      let parts
      if ((parts = location.hostname.split(".")).length === 3) {
        let first_part = parts.shift()
        // For french and spanish
        if (first_part.match(/fr|es|pt/)) {
          $(".modal-login-header").removeClass("modal-login-header").addClass("modal-login-header-other")
        }
        // for all other
        if (!first_part.match(/www/)) {
          $(".container-box .login-wrapper").removeClass("login-wrapper").addClass("login-wrapper-other")
          $(".or").removeClass("or").addClass("or-other")
          $("#smt-lang-selector").addClass("lang-selector-other")
        }
      }
    },

    addAfterLoginEvent: function (config) {
      // Add cookie for initiating like on server once login is success
      let jsonString = JSON.stringify(config)
      window.cookie("after_login_action", jsonString, { path: "/" })
    },

    bind_favorites: function (parentSelector) {
      let selectors = ".j-favorited, .j-favorite"
      $(parentSelector).delegate(selectors, "click", selectors, slideshare_object.favorites_handler)
    },

    favorites_handler: function (e) {
      let elmt = $(this)
      let slideshowId = elmt.attr("data-ssid")

      if (slideshare_object.user.loggedin) {
        e.preventDefault()
        e.stopPropagation()
        let isFavorited = !elmt.hasClass("favorited")
        let ssUrl = elmt.data("ss-url")
        let favoriteAction = isFavorited
          ? slideshare_object.favorites.create_url
          : slideshare_object.favorites.delete_url
        let config = {
          element: $(this),
          url: favoriteAction,
          selectors: e.data,
          event_category: "",
          is_favorited: isFavorited,
          ss_url: ssUrl,
          data: {
            slideshow_id: slideshowId,
            user_id: slideshare_object.user.id,
            source: "slideviewer",
            response_type: "json",
          },
        }
        slideshare_object.favorites_call_handler(config)
      } else {
        e.preventDefault()
        e.stopPropagation()
        let eventConfig = {
          event: "like",
          data: { slideshow_id: slideshowId },
        }
        slideshare_object.addAfterLoginEvent(eventConfig)
        scribdAuthorize({ from_source: window.location.pathname, slideshow_id: slideshowId })
      }
    },

    toggleLikeButton: function (index, elem) {
      $(elem).toggleClass("favorited")
      if ($(elem).hasClass("favorited")) {
        $(elem).addClass("animate")
        $(elem).one("webkitAnimationEnd oanimationend msAnimationEnd animationend", function (e) {
          $(elem).removeClass("animate")
        })
      }
    },

    favorites_call_handler: function (config) {
      let eventAction = config.is_favorited ? "favorite_click" : "unfavorite_click"
      window._gaq.push(["_trackEvent", config.event_category, eventAction])
      let initialStatus = config.is_favorited ? "unfavorited" : "favorited"
      let toggleLikeFn = function () {
        let $slideshow = config.element.closest(".iso_slideshow")
        if ($slideshow && $slideshow.length > 0) {
          $.each($slideshow.find(config.selectors), slideshare_object.toggleLikeButton)
        } else {
          $.each(config.element.parent().find(config.selectors), slideshare_object.toggleLikeButton)
        }
      }
      toggleLikeFn()
      $.ajax({
        url: config.url,
        data: config.data,
        dataType: "json",
        type: "POST",
        success: function (response) {
          if (response.success) {
            if (config.is_favorited) {
              slideshare_object.isHomePage() && slideshare_object.prompt_connect_li_and_ss()
            }
            let eventAction = config.is_favorited ? "favorite_click_success" : "unfavorite_click_success"
            window._gaq.push(["_trackEvent", config.event_category, eventAction])
          } else {
            // In failure condition
            toggleLikeFn()
          }
        },
        error: function (data) {
          toggleLikeFn()
        },
      })
    },

    favoritesStatusUpdate: function () {
      let sids = []
      let favoriteElements = $(".j-favorite")
      favoriteElements.each(function () {
        sids.push($(this).attr("data-ssid"))
      })
      $.ajax({
        type: "GET",
        url:
          slideshare_object.favorites && slideshare_object.favorites.user_favorites
            ? slideshare_object.favorites.user_favorites
            : "/favorite/get_favorites",
        data: "slideshow_id=" + sids.join(","),
        dataType: "json",
        success: function (data) {
          if (data.favorited.length > 0) {
            let filter = "[data-ssid=" + data.favorited.join("],[data-ssid=") + "]"
            favoriteElements.filter(filter).each(function () {
              $.each($(this).parent().children(".favorite-cta, .j-favorite, .j-favorited"), function (index, el) {
                //force like instead of toggle
                $(el).addClass("favorited")
              })
            })
          }
        },
      })
    },

    // TODO
    prompt_connect_li_and_ss: function () {},

    lazyloadThumbnails: function () {
      let llThumbs = function () {
        let thumbs = $(".j-lazy-thumb")
        if (thumbs.length > 0) {
          thumbs
            .lazyload({
              threshold: 100,
              failure_limit: 100,
            })
            .removeClass("j-lazy-thumb")
        }
      }
      if (slideshare_object.windowLoaded) {
        llThumbs()
      }
      $(window).load(function () {
        slideshare_object.windowLoaded = true
        llThumbs()
      })
    },

    autosuggestTop: function () {
      let $navSearchForm = $("#nav-search form")
      let $navSearchQuery = $("#nav-search-query")
      let $searchSuggestions = $("#nav-search .search-suggestions")
      let $searchSubmit = $("#search-submit")
      let searchTimeout

      // Initialize button disable state

      $searchSubmit.prop("disabled", ($navSearchQuery.val() ?? "").trim() === "")

      // Form submit

      $("body").on("submit", "#nav-search form", function () {
        $navSearchQuery.blur()
        $searchSuggestions.hide()
      })

      // Input gets focus

      $("body").on("focus", "#nav-search-query", function () {
        if (!$searchSuggestions.is(":empty")) {
          $searchSuggestions.show()
        }
      })

      // When clicking on a suggestion

      $("body").on("click", "#nav-search .search-suggestions li", function () {
        $navSearchQuery.val($(this).text())
        $searchSuggestions.hide()
        $navSearchForm.submit()
      })

      // Input looses focus

      $("body").on("focusout", "#nav-search-query", function () {
        searchTimeout = setTimeout(function () {
          $searchSuggestions.hide()
        }, 100)
      })

      // Clear focusout timeout if new element is one of the suggestions
      // (otherwise, if time elapsed between mousedown and mouseup on clicking
      // one of the suggestions is greater that 100ms, the suggestions will be
      // dismissed before the click event can execute)
      $("body").on("mousedown", ".search-suggestions", function () {
        // The mousedown event executes before the focusout event, so in order
        // to clear the timeout successfully, we must wait for it to be created
        setTimeout(function () {
          clearTimeout(searchTimeout)
        }, 50)
      })

      // Use classes instead of hover because it is also used with keys (up/down)

      $("body")
        .on("mousemove, mouseover", "#nav-search .search-suggestions li", function () {
          $searchSuggestions.children("li").removeClass("hovered")
          $(this).addClass("hovered")
        })
        .on("mouseout", "#nav-search .search-suggestions", function () {
          $searchSuggestions.children("li").removeClass("hovered")
        })

      // Typing handler

      let delay = (function () {
        let timer = 0
        return function (callback, ms) {
          clearTimeout(timer)
          timer = setTimeout(callback, ms)
        }
      })()

      $("body").on("keyup", "#nav-search-query", function (event) {
        delay(function () {
          /* Disable submit button if contents are empty */

          $searchSubmit.prop("disabled", event.target.value.trim() === "")

          /* Up/Down keys */

          if (parseInt(event.keyCode, 10) === 38 || parseInt(event.keyCode, 10) === 40) {
            let offset = -1
            if (parseInt(event.keyCode, 10) === 40) {
              offset = 1
            }

            let $suggestions = $searchSuggestions.children("li.suggestion")
            let $currentSuggestion = $(".search-suggestions li.suggestion.hovered")

            let nextSuggestionIndex = ($suggestions.index($currentSuggestion) + offset) % $suggestions.length
            let $nextSuggestion = $searchSuggestions.children("li.suggestion").eq(nextSuggestionIndex)

            $suggestions.removeClass("hovered")
            $nextSuggestion.addClass("hovered")

            $("#nav-search-query").val($nextSuggestion.text())
            return
          }

          /* Left/Right keys */

          if (parseInt(event.keyCode, 10) === 37 || parseInt(event.keyCode, 10) === 39) {
            return
          }

          /* Any other keys */

          let userQuery = encodeURIComponent($("#nav-search-query").val())

          var newAutoSuggestQuery = userQuery
            .replace(/[\(\)\[\]\!\#\~'"*&]/gi, "")
            .replace(/\s{2,}/g, " ")
            .trim(newAutoSuggestQuery)

          if (newAutoSuggestQuery.length === 0) {
            $searchSuggestions.empty().hide()
            return
          }

          if ($.inArray("site_search", slideshare_object.feature_flag) !== -1) {
            return
          }
        }, 50)
      })
    },

    // Checks if the given url is a download url
    isDownloadUrl: function (url) {
      url = url || window.location.href
      return (
        (getUrlVar("download_id", url) && getUrlVar("download_id", url).length > 0) ||
        getUrlVar("abbr", url) === "true" ||
        getUrlVar("from", url) === "download"
      )
    },

    // Generates a pseudo-random UUID
    generateUUID: function () {
      let d = Date.now()
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
        let r = (d + Math.random() * 16) % 16 | 0
        d = Math.floor(d / 16)
        return (c == "x" ? r : (r & 0x3) | 0x8).toString(16)
      })
    },
    // TODO: Remove as this exists in tracking-utils.js
    // Intended replacement for SecureRandom.hex
    generateTrackingID: function (n) {
      n = n || 16
      let result = "",
        tmp_str,
        pad = "0000"
      // Generate first 4 characters using the last 4 characters of slideshow_id
      if (typeof slideshare_object !== "undefined" && typeof slideshare_object.slideshow !== "undefined") {
        tmp_str = parseInt(slideshare_object.slideshow.id).toString(16).slice(-4)
        // We pad the result to have a more definitive schema
        result += (pad + tmp_str).slice(-pad.length)
      }
      // Generate next 4 characters of random string from using last 4 characters of _uv_id
      if (cookie("_uv_id") !== null) {
        // We pad the result to have a more definitive schema
        tmp_str = parseInt(cookie("_uv_id")).toString(16).slice(-4)
        result += (pad + tmp_str).slice(-pad.length)
      }
      n -= result.length
      while (n--) {
        result += Math.floor(Math.random() * 16)
          .toString(16)
          .toUpperCase()
      }
      return result
    },

    // Gets the pagekey for the current page
    getPageKey: function () {
      return /^pagekey-(.+)$/.exec(document.body.id)[1]
    },

    // jQuery Cross Domain Messaging Plugin
    // This allows us to register multiple callbacks to receiveMessage method
    // so we can split the receiveMessage responsibility

    // List of receivers
    crossDomainMessageReceivers: [],

    // jQuery Cross Domain Messaging Plugin initialization
    initCrossDomainMessaging: function () {
      //jQuery.receiveMessage( callback [, source_origin ] [, delay ] );
      // callback (Function) executes whenever a jQuery.postMessage message is received,
      // source_origin (String) If window.postMessage is available and this value
      //is not equal to the event.origin property, the callback will not be called.
      // delay (Number) An optional zero-or-greater delay in milliseconds.
      if ($.isFunction($.receiveMessage)) {
        $.receiveMessage(
          $.proxy(function (event) {
            $(this.crossDomainMessageReceivers).each(function (index, receiver) {
              receiver(event.data)
            })
          }, this),
          validateOrigin
        )
      }
    },

    // Register a jQuery Cross Domain Message receiver
    registerMessageReceiver: function (receiver) {
      this.crossDomainMessageReceivers.push(receiver)
    },
  })

  function validateOrigin(origin) {
    let isValidOrigin = origin === "http://" + location.host || origin === "https://" + location.host
    if (!isValidOrigin) {
      let hostParts = location.host.split(".")
      let subdomain = hostParts[0]
      if (["www", "fr", "es", "pt", "de"].includes(subdomain)) {
        hostParts[0] = subdomain + "2"
        isValidOrigin = origin === "http://" + hostParts.join(".") || origin === "https://" + hostParts.join(".")
      }
    }
    return isValidOrigin
  }

  /**
   * Replace regex character with its escaped version
   */
  function pregQuote(str) {
    return (str + "").replace(/([\\\.\+\*\?\[\^\]\$\(\)\{\}\=\!\<\>\|\:])/g, "\\$1")
  }

  $$.initCrossDomainMessaging()
})(slideshare_object, window.jQuery)
